import { Message } from './chatStorage';

const sanitizeCsvCell = (value: string): string => {
  const escaped = value.replace(/"/g, '""');
  return /^[=+\-@\t\r]/.test(escaped) ? `'${escaped}` : escaped;
};

export const exportChatToCSV = (messages: Message[], chatTitle: string) => {
  // CSV headers
  const headers = ['Role', 'Content', 'Module'];

  // Convert messages to CSV rows
  const rows = messages.map(message => {
    const role = message.role === 'user' ? 'User' : 'MIRA One';
    const content = sanitizeCsvCell(message.content);
    const roleCell = sanitizeCsvCell(role);
    const module = message.moduleDisplayName || '';
    const moduleCell = sanitizeCsvCell(module);

    return `"${roleCell}","${content}","${moduleCell}"`;
  });

  // Combine headers and rows
  const csvContent = [headers.join(','), ...rows].join('\n');

  // Create blob and download
  const BOM = '\uFEFF';
  const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);

  // Generate filename with timestamp
  const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, -5);
  const filename = `${chatTitle.replace(/[^a-z0-9]/gi, '_')}_${timestamp}.csv`;

  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Clean up
  URL.revokeObjectURL(url);
};
